export default __webpack_public_path__ + "img/b08341aeabbdadfd5ca230860b2460d5.svg";